import { render } from "./UserManage.vue?vue&type=template&id=71528f01&scoped=true"
import script from "./UserManage.vue?vue&type=script&lang=js"
export * from "./UserManage.vue?vue&type=script&lang=js"

import "./UserManage.vue?vue&type=style&index=0&id=71528f01&scoped=true&lang=css"

import exportComponent from "/Users/tandongling/Documents/vue/vue-argon-dashboard-2-pro-v3.0.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71528f01"]])

export default __exports__